import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isNumeric(val: unknown): val is number {
  return typeof val === 'number' && !Number.isNaN(val);
}

export function sortByTemplate<T, K extends string | number>(
  array: T[],
  mapper: (item: T) => K,
  template: readonly K[],
) {
  const indexMap = new Map(template.map((key, i) => [key, i]));

  return [...array].sort((a, b) => {
    const aKey = mapper(a);
    const bKey = mapper(b);

    return (indexMap.get(aKey) ?? Infinity) - (indexMap.get(bKey) ?? Infinity);
  });
}

export function compactNumber(value: unknown, locale: string): string {
  if (!isNumeric(value)) return String(value);

  const compact = new Intl.NumberFormat(locale, {
    notation: 'compact',
  }).format(value);

  return compact;
}
